import { useEffect, useState } from "react";
import axios from "axios";
import { PROPERTIES } from "@/data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function useProperties() {
  const [properties, setProperties] = useState(PROPERTIES);

  useEffect(() => {
    axios
      .get(`${API}/properties`)
      .then((res) => {
        if (Array.isArray(res.data) && res.data.length) {
          setProperties(res.data.map((p) => ({ ...p, id: p.slug })));
        }
      })
      .catch(() => {});
  }, []);

  return properties;
}
